import { useState } from 'react';

/**
 * Un ordre qui ne bouge plus des qu'on touche.
 *
 * Les langues cochees passent en tete a l'ouverture : on retrouve d'un
 * coup d'oeil ce qu'on avait choisi. Mais si l'ordre suivait chaque appui,
 * la langue qu'on vient de cocher sauterait en haut sous le doigt, et
 * l'appui suivant tomberait sur sa voisine. Tant que rien n'est touche, il
 * suit la valeur — un profil peut se charger apres le premier rendu ; au
 * premier appui, il se fige jusqu'a la prochaine ouverture.
 */
export function useOrdreFige<T>(ordre: readonly T[]): { ordre: readonly T[]; figer: () => void } {
  const [fige, setFige] = useState<readonly T[] | null>(null);
  const courant = fige ?? ordre;
  return {
    ordre: courant,
    figer: () => {
      if (!fige) setFige(courant);
    },
  };
}
